export default {
      id: "play-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#play",
      toString: function () {
        return this.url;
      }
    }